import { FC } from 'react';
import { Flex, Stack, Text } from '@chakra-ui/react';

import defaultStatCardStyle from './styles';

import { StatCardProps } from './StatCard.props';

const StatCardView: FC<StatCardProps> = (props) => {
  const {
    statusLabel,
    color,
    Icon,
    _bg,
    statValue = 0,
    selected,
    onSelectStatus,
    statusId,
    hideValue = false,
    type,
  } = props;

  return (
    <Stack
      direction={'row'}
      style={defaultStatCardStyle.cardContainer}
      maxWidth={'250px'}
      width={'100%'}
      maxHeight={'30vw'}
      height={'100%'}
      border="none"
      cursor="pointer"
      boxShadow="0 0 10px 0 rgba(0,0,0,0.1)"
      bg={
        typeof selected === 'number'
          ? selected === statusId
            ? _bg
            : '#fff'
          : selected?.includes(statusId)
          ? _bg
          : '#fff'
      }
      onClick={() => {
        if (type === 'orders' || type === 'pickups') {
          onSelectStatus?.(statusId);

          return;
        }

        if (typeof selected === 'number') {
          return;
        }

        if (selected?.includes(statusId)) {
          onSelectStatus?.(selected.filter((_sel) => _sel !== statusId));
        } else {
          onSelectStatus?.([...(selected || []), statusId]);
        }
      }}>
      <Icon size="2vw" color={color} />
      <Flex direction={'column'} columnGap={'2px'} alignItems={'start'}>
        <Text style={defaultStatCardStyle.cardText} color={color}>
          {statusLabel}
        </Text>
        {hideValue ? null : (
          <Text style={defaultStatCardStyle.cardNumber}>{statValue}</Text>
        )}
      </Flex>
    </Stack>
  );
};

export default StatCardView;
